import classNames from "classnames";
import { StorageScope } from "../../../../services/api/instances/storageApi/types/service_types";
import { AppIconButton } from "../../../../shared/components/AppIconButton";
import { RefreshIcon } from "../../../../shared/icons/RefreshIcon";
import { useRefreshDataButton } from "./hook/use-refresh-data-button";
import styles from "./styles.module.css";

interface Props {
  service: StorageScope;
  isLoading: boolean;
}

export const RefreshSidebarDataButton = ({ service, isLoading }: Props) => {
  const { handleRefreshData } = useRefreshDataButton(service);

  return (
    <AppIconButton
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        handleRefreshData();
      }}
      className={classNames(
        styles["refresh-data-btn"],
        isLoading && styles["loader"],
      )}
    >
      <RefreshIcon />
    </AppIconButton>
  );
};
